import { trigger, style, transition, animate } from '@angular/animations';
import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { SurveyViewerService } from '../../services/survey-viewer.service';

@Component({
  selector: 'empathy-question-view',
  templateUrl: 'question-view.component.html',
  styleUrls: ['./question-view.component.scss', './_question-view-theme.component.scss'],
  animations: [trigger('swapQuestion', [transition(':enter', [style({ opacity: 0 }), animate('150ms ease-in')])])]
})
export class QuestionViewComponent implements OnChanges {
  @Input() question: Question;
  @Input() questionCtrl: FormControl | FormArray | FormGroup;

  @Output() forceStop = new EventEmitter<boolean>();
  @Output() httpError = new EventEmitter<void>();

  fullSizeQuestions = [QuestionType.AIChat];
  noStimulusQuestions = [QuestionType.AIChat];

  questionType = QuestionType;

  private surveyViewerService = inject(SurveyViewerService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.question && changes.question.currentValue.type === QuestionType.Terminate) {
      this.questionCtrl.setValue(true);
      this.surveyViewerService.forceExit$.next(this.question.id);
    }
  }
}
